export default "__VITE_PUBLIC_ASSET__f175ae55__"